"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeImage = exports.validateImageSize = exports.validateImageType = void 0;
function validateImageType(img) {
    if (img.type === 'image/jpeg' || img.type === 'image/png') {
        return true;
    }
    return false;
}
exports.validateImageType = validateImageType;
var MAX_IMAGE_SIZE_BYTES = 4000000;
function validateImageSize(img) {
    return img.size < MAX_IMAGE_SIZE_BYTES;
}
exports.validateImageSize = validateImageSize;
function resizeImage(uploadedImage) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        var MAX_IMG_WIDTH = 1200;
        img.onload = function () {
            if (img.width <= MAX_IMG_WIDTH) {
                // don't resize if img is already small
                resolve(uploadedImage);
            }
            var canvas = document.createElement('canvas');
            var factor = MAX_IMG_WIDTH / img.width;
            canvas.width = MAX_IMG_WIDTH;
            canvas.height = canvas.width * (img.height / img.width);
            var fileType = uploadedImage.type || 'image/jpeg';
            var ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.drawImage(img, 0, 0, img.width * factor, img.height * factor);
                // lower quality is fine as long as digits are readable
                var imgQuality = 0.3;
                canvas.toBlob(function (blob) {
                    if (blob) {
                        var resizedFile = new File([blob], uploadedImage.name, {
                            type: fileType,
                        });
                        // tidy up
                        img.remove();
                        canvas.remove();
                        resolve(resizedFile);
                    }
                    else {
                        img.remove();
                        canvas.remove();
                        reject();
                    }
                }, fileType, imgQuality);
            }
        };
        img.src = URL.createObjectURL(uploadedImage);
    });
}
exports.resizeImage = resizeImage;
